/**
 * London calendar days, as YYYY-MM-DD strings.
 *
 * Every report is bucketed by London day (REPORT_TIMEZONE), so "today" and
 * "yesterday" mean London's today and yesterday, including across the BST
 * changeover. Intl does the timezone arithmetic; there is no hand-rolled
 * offset table to get wrong in March.
 */
import { REPORT_TIMEZONE } from './config';

const formatter = new Intl.DateTimeFormat('en-CA', {
  timeZone: REPORT_TIMEZONE,
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
});

/** The London calendar day containing this instant. */
export function londonDay(at: Date): string {
  return formatter.format(at);
}

/** A calendar day plus or minus whole days. Pure date arithmetic, no timezone involved. */
export function addDays(day: string, days: number): string {
  const d = new Date(`${day}T00:00:00Z`);
  d.setUTCDate(d.getUTCDate() + days);
  return d.toISOString().slice(0, 10);
}

/** Inclusive number of days from `from` to `to`. */
export function daysBetween(from: string, to: string): number {
  return Math.round((Date.parse(`${to}T00:00:00Z`) - Date.parse(`${from}T00:00:00Z`)) / 86_400_000) + 1;
}

export const DAY_PATTERN = /^\d{4}-\d{2}-\d{2}$/;
